export const USER_MODEL = 'user';

export interface User {
  id: number;
  name: string;
  email: string;
  external_role: string | null;
  language?: string;
  timezone?: string;
  country?: string;
}
